<!-- 缺陷等级分布 -->
<template>
  <a-card title="缺陷等级分布" size="small">
    <div id="defect-grade" :style="{ height: height, width: width }" />
  </a-card>
</template>
<script>
import { qualityDefectGrade } from '@/api/data/quality';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: {
        start_date: null,
        end_date: null,
        projects: null
      }
    }
  },
  data() {
    return {
      myChart: null,
      option: {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '1%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {},
        series: [
          {
            name: '缺陷等级分布',
            type: 'pie',
            center: ['50%', '58%'],
            data: [],
            label: {
              formatter: '{b}: {@2012} ({d}%)'
            },
            itemStyle: {
              borderRadius: 6,
              borderColor: '#fff',
              borderWidth: 2
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: 'bold'
              }
            }
          }
        ]
      }
    };
  },
  watch: {
    filterForm() {
      this.getDefectGradeData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/pie'); // 饼图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    this.myChart = echarts.init(document.getElementById('defect-grade'));
    this.getDefectGradeData();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },

    getDefectGradeData() {
      qualityDefectGrade(this.filterForm).then(res => {
        this.option.series[0].data = res.data.series;
        this.drawChart();
      });
    }
  }
};
</script>
